// Generated by ReScript, PLEASE EDIT WITH CARE


function Modal(props) {
  return props.children;
}

var Close;

var Container;

var Trigger;

var make = Modal;

export {
  Close ,
  Container ,
  Trigger ,
  make ,
}
/* No side effect */
